import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import times from 'lodash/times';
import constant from 'lodash/constant';
import map from 'lodash/map';
import { getCurrentBoats as bts } from '../../../utils/language';
import MiniListing from '../../../components/MiniListing';
import LoadingMiniListing from '../../../components/MiniListing/LoadingMiniListing';
import { addLead } from '../../../store/actions/dataLayer';
import messages from '../../../utils/translationMessages';
import { getConfig } from '../../../config/portal';
import { PortalConfigContext } from '../../../config/portal';
import {
  isManufacturerListing,
  showMoreProducts
} from '../../../utils/commonHelper';
import Link from '../../../components/SEO/Link';

import './styles.css';
import { hyphenateUrlComponents } from '../../../utils/urlHelpers/boats';
import { generateBrandedOemSearchPath } from '../../../utils/urlHelpers/oem/generateBrandedOemSearchPath';
import { getPartyBrandedSRP } from '../../../utils/urlHelpers/party';

class DealerOtherProducts extends PureComponent {
  clickDealerWebsite = () => {
    this.props.addLead(this.props.listingId, 'website referral');
  };

  renderMiniListings() {
    const currentLocale = this.props.intl.locale;
    const currencyCode = get(
      getConfig(),
      `languages.${currentLocale}.currency.abbr`,
      null
    );
    const customPricingOptions = {
      currency: get(
        getConfig(),
        `supportedCurrencies.${currencyCode}`,
        undefined
      ),
      formatingOptions: get(
        getConfig(),
        `languages.${currentLocale}.currency.format`,
        undefined
      )
    };

    let { dealerListings } = this.props;
    return map(dealerListings, (listing) => {
      return (
        <MiniListing
          key={listing.id}
          listing={listing}
          href={listing.href}
          listingType={bts().LISTING_SAME_DEALER}
          customPricingOptions={customPricingOptions}
        />
      );
    });
  }

  renderLoading() {
    let list = times(4, constant(null));
    return map(list, (_, index) => {
      return <LoadingMiniListing key={index} />;
    });
  }

  render() {
    const {
      listing: { isOemModel = false },
      dealerListings,
      isLoading,
      intl: { formatMessage: t },
      website
    } = this.props;
    const showMoreProductsButton = showMoreProducts(
      get(this.context, 'supports.moreProductsButton', false)
    );
    const isManufacturer = isManufacturerListing(isOemModel);
    let dealerWebsite = null;
    const listingId = get(this.props, 'listing.id', null);
    let moreFromThisButton = null;

    const getText = () => {
      if (isManufacturer) {
        return t(messages.moreFromManufacturer);
      }
      return t(messages.dealerBoats);
    };

    if (website) {
      dealerWebsite = (
        <a
          className="dealer-website"
          href={website}
          onClick={this.clickDealerWebsite}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {isManufacturer
            ? t(messages.viewManufacturerWebsite)
            : t(messages.viewDealerWebsite)}
        </a>
      );
    }

    if (showMoreProductsButton) {
      const make = get(this.props, 'listing.make', null);
      const dealer = get(this.props, 'listing.owner', null);

      const href = isOemModel
        ? generateBrandedOemSearchPath(
            {},
            {
              page: 1,
              brand: hyphenateUrlComponents(make)
            },
            true
          )
        : getPartyBrandedSRP(dealer, isOemModel, make);

      moreFromThisButton = (
        <Link
          className="more-products-button"
          data-reporting-click-internal-link-id="more from this dealer"
          href={href}
          onClick={() => {
            this.props.addLead(listingId, 'view all inventory');
          }}
        >
          {getText()}
        </Link>
      );
    }

    return (
      dealerListings.length > 0 && (
        <div id="dealer-boats-section" className="dealer-boats">
          <ul>
            {isLoading ? this.renderLoading() : this.renderMiniListings()}
          </ul>
          <div
            className={classnames({
              'generic-border flex-space-between': website || moreFromThisButton
            })}
          >
            {moreFromThisButton} {dealerWebsite}
          </div>
        </div>
      )
    );
  }
}

DealerOtherProducts.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    owner: PropTypes.shape({
      name: PropTypes.string
    }),
    isOemModel: PropTypes.bool
  }),
  listingId: PropTypes.number,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }).isRequired,
  isLoading: PropTypes.bool,
  addLead: PropTypes.func.isRequired,
  dealerListings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      owner: PropTypes.shape({
        name: PropTypes.string
      })
    })
  ),
  website: PropTypes.string
};

DealerOtherProducts.contextType = PortalConfigContext;

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addLead
    },
    dispatch
  )
)(injectIntl(DealerOtherProducts));
